import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>உபாகர்மா - அடிப்படை</h1>
  <!-- <mat-tab-group  mat-stretch-tabs >
    <mat-tab label="தமிழ்">
    </mat-tab>
    <mat-tab label="English">
    </mat-tab>
  </mat-tab-group> -->
  <div class="div4">
    <h2>யஜூர் உபாகர்மா - 11-08-2022</h2>
    <h2>போதாயன உபாகர்மா - 11-08-2022</h2>
    <h2>ருக் உபாகர்மா - 11-08-2022</h2>
    <h2>காயத்ரீ ஜபம் - 12-08-2022</h2>
    <h2>ஸாம உபாகர்மா - 30-08-2022</h2>
  </div>
  <mat-accordion>
    <mat-expansion-panel>
              <mat-expansion-panel-header>01. உபாகர்மாவின் அங்கங்கள்
          </mat-expansion-panel-header>
     <div class="div3">
      உபாகர்மாவில் நான்கு முக்கிய பாகங்கள் உள்ளன
      <br> (01) நித்ய கர்மா
      <br> (02) காமோகார்ஷீத் ஜபம்
      <br> (03) காண்டருஷி தர்பணம்
      <br> (04) வேதாரம்பம்
      <hr class="gold">
       </div>
       </mat-expansion-panel>
       <mat-expansion-panel>
        <mat-expansion-panel-header>02.முக்கியம் தேவையானவை 
    </mat-expansion-panel-header>
<div class="div3">
  <img src="assets/img/thingsRequired.jpg" style="width:90%">
  <ol class="myol">
  <li>ஒரு குடத்தில் ஜலம்</li>
  <li>திரும்ண் பெட்டி</li>
  <li>தாம்பாளங்கள்</li>
  <li>சொம்பு, டம்ளர்</li>
  <li>அக்ஷதை (அரிசி)</li>
  <li>கறுப்பு எள்</li>
  <li>உபாகர்மா மந்திரம்</li>
  <li>பூணல்கள், பவித்ரங்கள்</li>
  <li>மணைப்பலகை, மற்றவை</li>
  </ol>
 </div>
 </mat-expansion-panel>
 <mat-expansion-panel>
  <mat-expansion-panel-header>03. நித்ய கர்மா
</mat-expansion-panel-header>
<div class="div3">
  <h2>நித்ய கர்மா என்றால்? </h2>
  ஸந்த்யாவந்தனம் போன்ற தினமும் செய்யவேண்டிய வைதீக கடைமைகளே நித்யகர்மா எனப்படும். ப்ரஹ்மசாரிகளுக்கு: ப்ராதஸ்ஸ்நான, மௌஞ்சி -மேகலா
  -அஜின - தண்டதாரண, ஸந்தியாவந்தன, ஸமிதாதான, குருகுலவாஸ, ப்ரஹ்மயஜ்ஞ, பிக்ஷாசரண போன்றவை நித்ய கர்மாக்களாகும். க்ருஹஸ்தர்களுக்கு:
  ப்ராதஸ்ஸ்நான, (பஞ்சகச்ச) வஸ்த்ர தாராண, புண்ட்ர தாரண, ஸந்த்யாவந்தன, நித்ய ஔபாஸன, தேவயஜ்ஞ(பகவதாராதன), ப்ரஹ்மயஜ்ஞ,
  பித்ரு யஜ்ஞ, பூதயஜ்ஞ, மநுஷ்ய யஜ்ஞ இத்யாதி நித்ய கர்மாக்களாகும்.
</div>
</mat-expansion-panel>
<mat-expansion-panel>
  <mat-expansion-panel-header>04. காமோ கார்ஷீத் ஜபம்
</mat-expansion-panel-header>
<div class="div3">
  சாஸ்த்ரப்படி பார்த்தால் காமோகார்ஷீத்,
  காயத்ரி ஜபம் போன்ற ஜபங்கள் சூரிய உதயத்திற்கு
  பிறகுதான் செய்யவேண்டும். தலை
ஆவணியவிட்டம் செய்யும் ப்ரம்மச்சாரிக்கு மட்டும்
காமோகார்ஷீத் ஜபம் கிடையாது.
உபாகர்மம் என்றால் ஆரம்பம் என்றும்
உத்ஸர்ஜனம் என்றால் முடித்தல் என்றும் பொருள்.
தை மாதத்தில் உத்ஸர்ஜனம் செய்யப்பட்ட வேதம்
திரும்பவும் ஆவணி மாதத்தில்
உபாகர்மாவுடன் தொடங்குவதாகும்.
இந்த உத்ஸர்ஜனத்தை தை மாதத்தில் செய்யாமைக்குப்
ப்ராயச்சித்தமாக காமோகார்ஷீத் ஜபம்
செய்யப்படுகிறது என பெரியோர் கூறுவர்.
<br> நேரம் இருந்தால் 1008 முறை செய்வது சிறப்பு.
எண்ணிக்கைக்கு தர்பத்தை உபயோகிக்கக்கூடாது
எனச் சொல்லப்பட்டுள்ளது.
ஒருவேளை அணிந்துள்ள பூணல் பழுதாகி -
அறுந்துபோனதாக இருந்தால் காமோகார்ஷீத்
ஜபத்திற்கு முன்னதாகவே ஒரு முறை பூணல்
மாற்றிக்கொண்டு, மீண்டும் காண்டரிஷி
தர்பணத்தில் ஒரு முறை மாற்றிக்கொள்ளலாம்.
<br> காமோகார்ஷீத் ஜபம் முடிந்ததும்,
அமிழ்ந்து ஸ்நானம் பண்ணக்கூடிய ஆறு,
ஏரி, குளம் போன்றவற்றில் ஸ்நானம் செய்வது மிகச்
சிறந்தது. ஸ்நானம் செய்து, மாத்யாஹ்நிகம் முடித்துவிட்டு
காண்டரிஷி தர்பணம் செய்யவேண்டும். தளிகை சித்தமாகியிருந்து,
காண்டரிஷி தர்பணம் செய்ய கால தாமதம் ஏற்பட்டு,
இடையில் நேரம் இருக்குமானால், பெருமாள் திருவாராதனத்தை முடித்து,
பர்யங்காஸனத்தில் பெருமாளை ஏளப்பண்ணிவிட்டு,
தீர்த்தம் மட்டும் எடுத்துக்கொள்ளாமல் பின்னர் காண்டரிஷி தர்பணத்தை
முடித்துவிட்டு வந்து பெருமாள் ஸேவித்து தீர்த்தம் எடுத்துக்கொள்ளலாம்.
<br> ஆவணி அவிட்டம் - உபாகர்மா செய்து மறுநாள் காயத்ரி
 ஜபம் இருப்பதால் சுத்த உபவாசம் இருக்கவேண்டும் என்று சிஷ்டாசாரம்.
ஆனால் பலர் காண்டருஷி தர்பணம் பண்ணுவதற்கு
முன்னதாகவே இட்லி, அப்பம் எல்லாம் எடுத்துக்கொண்டு பின்னர் உபாகர்மா
செய்கின்றனர். அது மிகத் தவறானதாகும்.
</div>
</mat-expansion-panel>
<mat-expansion-panel>
  <mat-expansion-panel-header>05. காண்டருஷி தர்பணம்
</mat-expansion-panel-header>
<div class="div3">
  இதை ருஷி தர்பணம், பித்ரு தர்பணம் என மேலும்
  இரு பிரிவாகப் பிரிக்கலாம். முதல் பிரிவை அனைவரும் செய்யவேண்டும்,
  இரண்டாவது
தகப்பனார் இல்லாதவர்கள் மட்டும் செய்யவேண்டும். ஆனால்,
 இதில் சொல்லப்பட்டுள்ள தர்பணங்கள் முன்னோர்களான பித்ருக்களுக்குக்
கிடையாது. பித்ருக்களுக்கு அநுகூலமாக உள்ள தேவதைகளுக்கான
தர்பணம் இது என்பதால் இதை அனைவரும் செய்வதால் எந்தத் தீமையும்
இல்லை. காண்டருஷி தர்பணம செய்வதற்கு முன்னால்,
உபாகர்மாவுக்கு அங்கமாக பூணல் மாற்றிக்கொள்ளவவேண்டும்.
</div>
</mat-expansion-panel>
<mat-expansion-panel>
  <mat-expansion-panel-header>06. வேதாரம்பம்
</mat-expansion-panel-header>
<div class="div3">
  உபாகர்மாவின் இறுதி அங்கம்.
                  இந்த நாளில் வேதத்தை அத்யயனம் செய்ய
                  ஆரம்பிக்கவேண்டும் என்பதால், வேதத்தின்
                  எல்லா பாகங்கங்களிலிருந்தும்
                ஒரு குறிப்பிட்ட பகுதியை ஜபம் செய்வது வேதாரம்பம் ஆகும்.
                லௌகீகர்களான நாம், ஒவ்வொரு வருடமும் உபாகர்மா அன்று மட்டும்
                4 வாக்கியங்களைச் சொல்லிவிட்டு அத்துடன் மறந்தும்விடுகிறோம்.
                 அதனால் மீண்டும் மீண்டும் அதே 4 வாக்கியங்களைச் சொல்கிறோம்.
</div>
</mat-expansion-panel>
<mat-expansion-panel>
  <mat-expansion-panel-header>07. சில குறிப்புகள்
</mat-expansion-panel-header>
<div class="div3">
  வேதாரம்பம் முழுமையாகக்கொடுக்கப்பட்டுள்ளது
                  நேரம் இல்லாதவர்கள் எப்போதும்போல
                  4 வாக்கியங்களை மட்டும் சொல்லி முடித்துக்கொள்ளவும்.
</div>
</mat-expansion-panel>
<mat-expansion-panel>
  <mat-expansion-panel-header>08. உபாகர்மா வீடியோக்கள்
</mat-expansion-panel-header>
<div class="div3">
  <h1>உபாகர்மா - 2020 வீடியோ</h1>
  <ion-item>
    <div class="video-container">
      <iframe src="https://www.youtube.com/embed/d-91w9wcXmg" frameborder="0" width="300" height="169"></iframe>
    </div>
    </ion-item>
</div>
<div class="div3">
  கீழே ஶ்ரீஶ்ரீக்ருஷ்ணப்ரேமி அண்ணா அவர்கள் உபாகர்மா
  பற்றி மிக விளக்கமாக அளித்துள்ள உபந்யாஸத்தைக் கேட்டால் அனைவருக்கும்
இதில் ச்ரத்தையும் ஈடுபாடும் வரும் என்பதால் அந்த உபந்யாஸத்தை
இத்துடன் இணைத்துள்ளோம். உபாகர்மாவுக்கு முன்னர்
ஒரு முறையும். உபாகர்மா ஆனபிறகு அனைவரும் ஓய்வாக
உட்கார்ந்திருக்கும்போது ஒருமுறையும் போட்டுக் கேட்கவும்.
<br> வைதீக, சாஸ்த்ர, ஸம்ப்ரதாய விஷயங்களில்
எந்த ஸந்தேஹமாக இருந்தாலும் அடியேனைத் தயங்காமல்
ஈமெயில் மூலம் தொடர்புகொள்ளவம்.


<h2>Yajur Upakrma Videos</h2>
வழங்கப்பட்டுள்ள வீடியோக்களில் தேதி போன்றவை
   ஏதேனும் பிழையிருந்தால் பொருட்படுத்தாமல் சரியான
   விஷயங்களை உபயோகித்து
பின்பற்றவும்.

<ion-item>
<div class="video-container">
  <iframe src="https://www.youtube.com/embed/7c16LgJxQYM?rel=0" frameborder="0" width="300" height="169"></iframe>
</div>
</ion-item>
<ion-item>
<div class="video-container">
  <iframe src="https://www.youtube.com/embed/FMW9Lk0qBwI?rel=0" frameborder="0" width="300" height="169"></iframe>
</div>
</ion-item>

</div>
</mat-expansion-panel>
  </mat-accordion>`;

const UpakarmaPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="முன் தயாரிப்பு - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default UpakarmaPage;
